export const FETCH_PERMISSIONS = 'fetch-permissions';